(ns app.front.view.group.admin.fees.schedule.schedule-modal
  (:require [app.domain.fee.model :as fee-model]
            [app.front.entities :as entities]
            [app.front.ui :as ui]
            [app.front.ui.multi-select :as ms]
            [app.front.view.group.admin.fees.schedule.schedule-events :as fs-events]
            [app.front.view.group.admin.subs :as gas]
            [core.front.event :refer [<sub >evt]]
            [core.util.util :as util]
            [re-frame.core-instrumented :as rf]))

(rf/reg-sub ::superdomain-fee-schedules
  :<- [::entities/context]
  :<- [::gas/superdomain-id]
  :<- [::gas/group-primary-permit-type]
  (fn [[ctx superdomain-group-id permit-type]]
    (when (and superdomain-group-id permit-type)
      (entities/find-entities ctx {:entity/parent            superdomain-group-id
                                   :entity/type              :entity.type/fee-schedule
                                   :fee-schedule/permit-type permit-type}))))

(rf/reg-sub ::open-copy-modal?
  :-> ::open-copy-modal?)

(rf/reg-event-db ::open-copy-modal
  (fn [db _]
    (assoc db ::open-copy-modal? true)))

(rf/reg-event-db ::close-copy-modal
  (fn [db _]
    (dissoc db ::open-copy-modal?)))


(rf/reg-event-db ::select-for-copy
  (fn [db [_ items]]
    (assoc db ::selected-for-copy (set items))))

(rf/reg-sub ::selected-for-copy
  :-> ::selected-for-copy)

(rf/reg-event-fx ::copy-superdomain-fee-schedules
  (fn [{:keys [db]} [_ authority-group-id selected-schedules]]
    (let [fee-schedule-ids (set (map :db/id selected-schedules))]
      {:db           (assoc-in db [::fs-events/fees :schedules-duplicating?] true)
       :comm/command {:command    :fee/copy-superdomain-fee-schedules
                      :method     :post
                      :data       (util/mmap fee-schedule-ids authority-group-id)
                      :on-success [::fs-events/update-success fee-schedule-ids :fees/schedule-copied]}})))


(defn copy-schedules-modal [tr]
  (let [fee-schedules      (<sub [::superdomain-fee-schedules])
        authority-group-id (<sub [::gas/group-id])
        lang               (<sub [:language])
        selected-schedules (<sub [::selected-for-copy])]
    [ui/confirm-modal
     {:id              "select-schedules-to-copy"
      :open?           (<sub [::open-copy-modal?])
      :yes-disabled?   (empty? selected-schedules)
      :on-close        #(>evt [::close-copy-modal])
      :on-yes-click    #(>evt [::copy-superdomain-fee-schedules authority-group-id selected-schedules])
      :modal-title     (tr [:fees/select-fees-schedules-to-copy] [(:group/name (<sub [::gas/superdomain]))])
      :no-button-text  (tr [:cancel])
      :yes-button-text (tr [:copy])
      :tr              tr}
     [:div.flex.flex-col.mb-8
      [ms/multi-checkbox
       {:id         "select-schedules"
        :val->str   #(or (fee-model/fee-schedule-title % lang) "")
        :val->token :db/id
        :values     fee-schedules
        :on-change  #(>evt [::select-for-copy %])
        :selected   (or selected-schedules #{})
        :tr         tr}]]]))
